export enum TPFeatureFlags {
    //added in 25.05
    ProcessSpecialRules = 'process-special-rules',
    //added in 25.12
    EnableRelatedSpecialties = 'enable-related-specialties',
    //added in 25.16
    EnableDocAdminCandidateReviewUpload = 'enable-doc-admin-candidate-review-upload',
    RulesConflictFilter = 'rules-conflict-filter',
    //added in 26.02
    ShowSystemGeneratedNotesInIntegrationStatusesColumn = 'show-system-generated-notes-in-integration-statuses-column',
    DisableAutoPrefixForLegacyContracts = 'disable-auto-prefix-for-legacy-contracts',
    DocumentAdminClientRuleConflictsReport = 'document-admin-client-rule-conflicts-report'
}
